<template>
  <div class="content">
    <van-popup
      v-model="showCoupon5"
      @close="close5(1)"
      close-on-click-overlay
      class="saveRes1"
      round
      style="margin-top: -20px; z-index: 1800"
      closeable
    >
      <div
        ref="CodeDiv"
        v-show="showPng5"
        class="ss pop_tacbox CodeDiv"
        style="
          height: 535px;
          max-width: 90vw;
          background: #fff;
          padding-top: 35px;
          position: relative;
        "
      >
        <div class="pop tac">
          <div
            style="position: absolute; top: 14px; left: 14px; text-align: left"
          >
            <img
              style="width: 117px; vertical-align: middle; margin-top: -2px"
              src="data:image/png;base64,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"
            />
          </div>
          <div class="pop_imgbox">
            <img
              :src="headImg5 + '?any_string_is_ok'"
              ref="img"
              id="imgId"
              crossorigin="anonymous"
            />
          </div>
          <div
            style="
              background: #fff;
              padding-top: 120px;
              margin-top: -106px;
              padding-bottom: 40px;
              border-radius: 12px;
            "
          >
            <p class="f20 mt-20 pop_textTitleBox">
              <b class="pop_textTitle">{{ testTitle5 }}</b>
            </p>
            <p class="f16 mt-10 pop_testDiscribe">{{ testDiscribe5 }}</p>
            <p class="mt-5 f10 light">
              {{ testDiscribe15 }}&nbsp;&nbsp;
              <span>{{ testNum5 }}道精选问题</span>&nbsp;&nbsp;
              <span v-if="ReportNum5 == 0">专业测评报告 </span>
              <span v-else>{{ ReportNum5 }}字测评报告 </span>
              &nbsp;&nbsp;<span>{{ peopleNum5 }}人已测</span>&nbsp;
            </p>
          </div>

          <div class="showImgSave">
            <div class="showImgSave_left">
              <div class="showImgSave_left_imgbox">
                <img :src="user.avatar" alt="" />
                <p class="left_imgbox_title">
                  {{
                    user.nick_name && user.nick_name.length > 10
                      ? user.nick_name.slice(0, 10) + "..."
                      : user.nick_name
                  }}
                </p>
              </div>
              <p class="Save_left_text">
                “ 嗨～ 扫描右侧二维码， 一起加入测试吧。”
              </p>
            </div>
            <div class="showImgSave_right">
              <div class="ma" ref="rightCode"></div>
            </div>
          </div>
        </div>
      </div>
      <img :src="imgData5" ref="resImg" class="savePic pop_tacbox" />
    </van-popup>
    <div class="btn" @click="showImg5">生成专属邀请卡去分享</div>
    <div class="btn1" @click="showImg5">生成专属邀请卡去分享</div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";
import { Loading } from "element-ui";
import { mapGetters } from "vuex";
import { getTestDetail } from "@/http/api";
export default {
  name: "goldDes",
  data() {
    return {
      showPng5: true,
      showCoupon5: false,
      eval_id5: "",
      headImg5: "",
      testTitle5: "",
      testDiscribe5: "",
      testDiscribe15: "",
      testNum5: 0,
      ReportNum5: 0,
      closeImg5: require("./../../../assets/img/test/close.png"),
      peopleNum5: 0,
      imgData5: "",
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  created() {
    this.eval_id = this.$route.path.match(/\d+/)[0];
    console.log(this.user);
    console.log(html2canvas);
    getTestDetail(this.eval_id5).then((res) => {
      this.headImg5 = res.data.home_image;
      this.testTitle5 = res.data.title;
      this.testDiscribe5 = res.data.intro;
      this.testDiscribe15 = res.data.intro_text;
      this.testNum5 = res.data.question_list.length;
      this.ReportNum5 = res.data.report_num;
      this.peopleNum5 = res.data.evaluation_times;
    });
  },
  methods: {
    getBase64Image5(img) {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, img.width, img.height);
      var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
      var dataURL = canvas.toDataURL("image/" + ext);
      return dataURL;
    },

    close5() {
      this.showCoupon5 = false;
      this.$refs.rightCode = "";
    },
    showImg5() {
      this.showCoupon5 = true;
      this.$nextTick(() => {
        this.bindQRCode5();
      });
    },
    bindQRCode5() {
      let t = this;
      console.log("this.$refs", this.$refs.rightCode);
      console.log("this.eval_id", this.eval_id);
      const url = window.location.href.split("#")[0];
      this.localUrl = url;
      // let url = window.location.href.split("#")[0];
      new QRCode(this.$refs.rightCode, {
        text:
          "http://h5.coolbrainscience.cn/#/test/" +
          this.eval_id +
          "/introduction?user_id=" +
          this.user.user,
        // text: this.localUrl + "#/my/send/" + this.code,
        width: this.$refs.rightCode.clientWidth - 8,
        height: this.$refs.rightCode.clientHeight - 8,
        colorDark: "#42686E", // 二维码颜色
        colorLight: "#ffffff", // 二维码背景色
        correctLevel: QRCode.CorrectLevel.L, // 容错率，L/M/H
      });
      this.$nextTick(() => {
        this.createPicture5();
      });
    },
    createPicture5() {
      window.scrollTo(0, 0);
      let content = this.$refs.CodeDiv;
      console.log(this.$refs.CodeDiv);
      let width = content.offsetWidth;
      let height = content.offsetHeight;
      let scale = window.devicePixelRatio;

      let shareContent = document.getElementsByClassName("saveRes")[0];
      //  console.log(shareContent)
      const rect = shareContent.getBoundingClientRect();
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop; // 获取滚动轴滚动的长度
      let opt = {
        useCORS: true,
        tainttest: true,
        backgroundColor: "#ECEFF5",
        width: Math.round(width),
        height: Math.round(height),
        scale: scale,
        x: rect.left,
        y: rect.top,
        scrollX: 0,
        // scrollY: 0,
        scrolly: -window.pageyoffset,
        logging: true,
      };
      console.log(this.$refs);
      console.log(opt);
      let loadingInstance = Loading.service({
        fullscreen: true,
        text: "生成分享图片中...",
      });
      window.pageYOffset = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      // setTimeout(function () {
      setTimeout(() => {
        html2canvas(document.getElementsByClassName("CodeDiv")[0], opt)
          .then((canvas) => {
            this.firstFlag5 = false;
            console.log("生成");
            var imgData5 = canvas.toDataURL("image/jpeg");
            this.imgData5 = imgData5;
            this.showPng5 = false;
            loadingInstance.close();
          })
          .catch((error) => {
            loadingInstance.close();
            console.log("错误", error);
          });
      }, 1000);

      // }, 1000);
    },
  },
};
</script>

<style lang="less" scoped>
@import "~Style/index.less";

.content {
  width: 100vw;
  height: 648vw;
  background-image: url("./../../../assets/img/test/goldhelp.png");
  background-repeat: no-repeat;
  background-size: contain;
  text-align: center;
  position: relative;

  .btn {
    background: linear-gradient(to left, #fe6f28, #f6a624);
    width: 82vw;
    height: 45px;
    border-radius: 18px;
    margin-left: 9vw;
    position: absolute;
    text-align: center;
    line-height: 45px;
    font-size: 18px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #ffffff;
    top: 148vw;
  }

  .btn1 {
    background: linear-gradient(to left, #fe6f28, #f6a624);
    width: 82vw;
    height: 45px;
    border-radius: 18px;
    margin-left: 9vw;
    position: absolute;
    text-align: center;
    line-height: 45px;
    font-size: 18px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #ffffff;
    top: 626vw;
  }
}

.closeImg {
  height: 30px;
  width: 30px;
  margin: 0 auto;
}

.saveRes1 {
  position: fixed;

  .pop_tacbox {
    .w(337);
    // height: 568px;
    // padding-top: 18px;
    // background-color: #fff;
    // position: fixed;
    border-radius: 32px;

    // overflow: hidden;
    .pop_imgbox {
      width: 180px;
      height: 180px;
      border-radius: 254px;
      margin: 0 auto;
      padding-top: 18px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 254px;
      }
    }

    .pop_textTitleBox {
      margin-top: 10px;

      .pop_textTitle {
        font-size: 26px;
        font-weight: bold;
      }
    }

    .pop_testDiscribe {
      line-height: 30px;
      margin-top: 0;
    }

    .light {
      margin-top: 0;
    }

    .code_copy {
      margin: 10px 0;
      .w(237);
    }

    .code_box {
      line-height: 30px;
      position: relative;
    }

    .code_save {
      .w(236);
      height: 46px;
      font-size: 0.48rem;
      color: #fff;
      border-radius: 0.5rem;
      background-color: #42686e;
      line-height: 46px;
      text-align: center;
    }

    .code_save_icon {
      display: inline-block;
      width: 14px;
      height: 100%;
      margin-right: 8px;

      img {
        width: 17px;
        height: 16px;
        border-radius: 0;
        vertical-align: middle;
      }
    }

    .showImgSave {
      .w(337);
      height: 140px;
      background: #d6e6e8;
      border-radius: 32px;
      // border-top-right-radius: 32px;
      position: absolute;
      left: 0;
      bottom: 0;
      box-sizing: border-box;
      padding: 0 24px 0 21px;

      .showImgSave_left_imgbox {
        display: flex;
        align-items: center;

        img {
          width: 36px;
          height: 36px;
          margin-right: 5px;
        }
      }

      .showImgSave_left {
        .w(160);
        height: 100%;
        padding-top: 22px;
        font-size: 12px;
        float: left;

        .left_imgbox_title {
          color: #4a4a4a;
          font: 14px bold;
        }

        .Save_left_text {
          color: #9b9b9b;
          line-height: 18px;
          text-align: left;
          margin-top: 11px;
        }
      }

      .showImgSave_right {
        float: right;
        text-align: center;
        .w(98);
        height: 100%;

        .savePic {
          border-radius: 0;
          width: 100%;
          height: 100%;
          margin-top: 0;
          position: fixed;
        }

        .showImgSave_code {
          color: #42686e;
          font: 18px;
        }
      }
    }
  }

  .ma {
    .w(88px);
    height: 88px;
    border: 3px solid #42686e;
    padding: 4px;
    border-radius: 8px;
    margin-top: 15px;
    margin-bottom: 8px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .ma {
    .w(88px);
    height: 88px;
    border: 3px solid #42686e;
    padding: 4px;
    border-radius: 8px;
    margin-top: 15px;
    margin-bottom: 8px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .savePic {
    padding: 0;
  }
}
</style>
